<template>
    <div
        class="md item-info"
        :class="[hasAction? 'has-action': '', theme? 'is-'+ theme: '', size? 'size-'+ size: '']"
        @click="runAction"
    >
        <div class="caption" v-html="caption"></div>
        <div class="div">
            <span v-if="icon" class="cp status icon-font targets" :class="[icon]"></span>
            <div class="essay">{{ $okaTool.numberToStringFormat(computedValue, this.fixed) }}</div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            caption: {
                type: String,
                required: false,
                default: ''
            },
            theme: {
                type: String,
                required: false,
                default: ''
            },
            icon: {
                type: String,
                required: false,
                default: ''
            },
            value: {
                type: Number,
                required: false,
                default: 0
            },
            action: {
                type: Function,
                required: false
            },
            fixed: {
                type: Number,
                required: false,
                default: 2
            },
            int: {
                type: Number,
                required: false,
                default: 60
            },
            speed: {
                type: Number,
                required: false,
                default: 300
            },
            size: {
                type: String,
                required: false,
                default: ''
            },
        },
        data: function(){

            return {
                timer: null,
                computedValue: 0
            }
        },
        computed: {
            hasAction: function() {

                if( this.action ) {
                    return true;
                }else {
                    return false;
                }
            }
        },
        watch: {
            value: {
                handler: function(){
                    this.runComputed();
                }
            }
        },
        methods: {
            runComputed: function(){
                clearInterval(this.timer);
                this.computedValue = 0;

                let _value = this.value;

                let _int = this.int, //分幾格
                    _base = _value / _int,
                    _speed = this.speed / _int;

                this.timer = setInterval(() => {
                    this.computedValue += _base;

                    if(this.computedValue >= _value){
                        this.computedValue = _value;
                        clearInterval(this.timer);
                    }
                }, _speed);
            },
            runAction: function(){

                if( this.hasAction ) {
                    this.action();
                }
            }
        },
        created: function(){
            this.runComputed();
        }
    }
</script>

<style scoped lang="scss">

    .md.item-info {
        padding: 0;
        text-align: center;
        overflow: hidden;

        .g.card &, .g.grid-card & {
            box-shadow: 0 0 0;
        }

        // @include media('phone') {
        //     text-align: left;
        // }

        &.has-action {
            cursor: pointer;
            @extend %card-hover;
        }

        &.size-l {

            .cp.status {
                vertical-align: 4rem;
            }
        
            .essay {
                font-size: 5em;
            }
        }

        &.size-s {

            .cp.status {
                vertical-align: 1.5rem;
            }
        
            .essay {
                font-size: 2em;
            }
        }

        @each $key, $map in $colors {
            $tx: map-get($map, 'text');

            &.is-#{$key} {

                .cp.status {
                    color: $tx;
                }

                .essay {
                    color: $tx;
                }
            }
        }
        
        .caption {
            transition: $transition;
            padding: $interval-s;
            background-color: $major-color;
            color: $white;
            @extend %ellipsis;
        }

        .div {
            padding: $interval-s $interval-s $interval-m;
            @extend %ellipsis;
            white-space: nowrap;
            background-color: $third-color;
        }

        .cp.status {
            vertical-align: 2rem;
        }

        .essay {
            display: inline-block;
            font-size: 3em;
            line-height: 1.5em;
        }

        .label {
            display: inline-block;
            margin-left: $interval-xs;
        }
    }
</style>
